// 不同国家对应的政府机构(部门)
export const governmentData = {
  Singapore: [
    {
      value: "ACRA",
      zh: "会计与公司监管局-ACRA \n Accounting & Corporate Regulatory Authority - ACRA",
      en: "Accounting & Corporate Regulatory Authority - ACRA",
    },
    {
      value: "BOA",
      zh: "新加坡建筑师委员会-BOA \n Board of Architects, Singapore - BOA",
      en: "Board of Architects, Singapore - BOA",
    },
    {
      value: "MUIS",
      zh: "新加坡乌加马伊斯兰理事会-MUIS \n Majlis Ugama Islam Singapura - MUIS",
      en: "Majlis Ugama Islam Singapura - MUIS",
    },
    {
      value: "Charities Unit",
      zh: "文化、社区和青年部-慈善股-Charities Unit \n Ministry of Culture, Community and Youth - Charities Unit",
      en: "Ministry of Culture, Community and Youth - Charities Unit",
    },
    {
      value: "Minlaw",
      zh: "Minlaw（法律服务监管局）-Minlaw \n Minlaw (legal services regulatory authority) - Minlaw",
      en: "Minlaw (legal services regulatory authority) - Minlaw",
    },
    {
      value: "MAS_Bank",
      zh: "新加坡金融管理局（银行部）-MAS银行 \n Monetary Authority of Singapore (Banking Department) - MAS_Bank",
      en: "Monetary Authority of Singapore (Banking Department) - MAS_Bank",
    },
    {
      value: "CEA",
      zh: "地产代理协会-CEA \n Council for Estate Agencies - CEA",
      en: "Council for Estate Agencies - CEA",
    },
    {
      value: "CTA",
      zh: "新加坡企业-CTA \n Enterprise Singapore - CTA",
      en: "Enterprise Singapore - CTA",
    },
    {
      value: "Mindef",
      zh: "国防部长-Mindef \n Minsitry of Defence - Diso - Mindef",
      en: "Minsitry of Defence - Diso - Mindef",
    },
    {
      value: "MOE",
      zh: "教育部私立学校-MOE \n Minsitry of education - private schools section - MOE",
      en: "Minsitry of education - private schools section - MOE",
    },
    {
      value: "Professional Engineers Board",
      zh: "专业工程师委员会-Professional Engineers Board \n Professional Engineers Board - Professional Engineers Board",
      en: "Professional Engineers Board - Professional Engineers Board",
    },
    {
      value: "STB",
      zh: "新加坡旅游局-STB \n Singapore Tourism Board - STB",
      en: "Singapore Tourism Board - STB",
    },
    {
      value: "RCA",
      zh: "新加坡企业-RCA \n Enterprise Singapore - RCA",
      en: "Enterprise Singapore - RCA",
    },
    {
      value: "MFA",
      zh: "外交部-MFA \n Ministry of foreign affairs - MFA",
      en: "Ministry of foreign affairs - MFA",
    },
  ],
  Malaysia: [
    {
      value: "SSM",
      zh: "马来西亚企业管制局-SSM \n Suruhanjaya Syarikat Malaysia - SSM",
      en: "Companies Commission of Malaysia - SSM",
    },
    {
      value: "BNM",
      zh: "马来西亚国家银行-BNM \n Bank Negara Malaysia - BNM",
      en: "Central Bank of Malaysia - BNM",
    },
    {
      value: "LHDN",
      zh: "马来西亚内陆税收局-LHDN \n Lembaga Hasil Dalam Negeri - LHDN",
      en: "Inland Revenue Board of Malaysia - LHDN",
    },
    {
      value: "MIDA",
      zh: "马来西亚投资发展局-MIDA \n Lembaga Pembangunan Pelaburan Malaysia - MIDA",
      en: "Malaysian Investment Development Authority - MIDA",
    },
    {
      value: "SC",
      zh: "马来西亚证券监督委员会-SC \n Suruhanjaya Sekuriti Malaysia - SC",
      en: "Securities Commission Malaysia - SC",
    },
    {
      value: "MITI",
      zh: "马来西亚投资、贸易及工业部-MITI \n Kementerian Pelaburan, Perdagangan dan Industri - MITI",
      en: "Ministry of Investment, Trade and Industry - MITI",
    },
    {
      value: "MOF",
      zh: "马来西亚财政部-MOF \n Kementerian Kewangan Malaysia - MOF",
      en: "Ministry of Finance - MOF",
    },
    {
      value: "MCMC",
      zh: "马来西亚通讯及多媒体委员会-MCMC \n Suruhanjaya Komunikasi dan Multimedia Malaysia - MCMC",
      en: "Malaysian Communications and Multimedia Commission - MCMC",
    },
    {
      value: "MOH",
      zh: "马来西亚卫生部-MOH \n Kementerian Kesihatan Malaysia - KKM",
      en: "Ministry of Health - MOH",
    },
    {
      value: "MOE",
      zh: "马来西亚教育部-MOE \n Kementerian Pendidikan Malaysia - KPM",
      en: "Ministry of Education - MOE",
    },
    {
      value: "MHE",
      zh: "马来西亚高等教育部-MHE \n Kementerian Pendidikan Tinggi - KPT",
      en: "Ministry of Higher Education - MHE",
    },
    {
      value: "MOT",
      zh: "马来西亚交通部-MOT \n Kementerian Pengangkutan Malaysia - MOT",
      en: "Ministry of Transport - MOT",
    },
    {
      value: "MFA",
      zh: "马来西亚外交部-MFA \n Kementerian Luar Negeri - Wisma Putra",
      en: "Ministry of Foreign Affairs - MFA",
    },
    {
      value: "MINDEF",
      zh: "马来西亚国防部-MINDEF \n Kementerian Pertahanan Malaysia - MINDEF",
      en: "Ministry of Defence - MINDEF",
    },
    {
      value: "MOHR",
      zh: "马来西亚人力资源部-MOHR \n Kementerian Sumber Manusia - KSM",
      en: "Ministry of Human Resources - MOHR",
    },
    {
      value: "JAKIM",
      zh: "马来西亚伊斯兰发展局-JAKIM \n Jabatan Kemajuan Islam Malaysia - JAKIM",
      en: "Department of Islamic Development Malaysia - JAKIM",
    },
    {
      value: "BEM",
      zh: "马来西亚工程师局-BEM \n Lembaga Jurutera Malaysia - LJM",
      en: "Board of Engineers Malaysia - BEM",
    },
    {
      value: "LAM",
      zh: "马来西亚建筑师局-LAM \n Lembaga Arkitek Malaysia - LAM",
      en: "Board of Architects Malaysia - LAM",
    },
    {
      value: "BOVAEP",
      zh: "马来西亚估价师、评价师、地产代理及物业管理人局-BOVAEP \n Lembaga Penilai, Pentaksir, Ejen Harta Tanah & Pengurus Harta - LPPEH",
      en: "Board of Valuers, Appraisers, Estate Agents and Property Managers - BOVAEP",
    },
    {
      value: "Tourism Malaysia",
      zh: "马来西亚旅游局-Tourism Malaysia \n Lembaga Penggalakan Pelancongan Malaysia - Tourism Malaysia",
      en: "Malaysia Tourism Promotion Board - Tourism Malaysia",
    },
  ],
};
